/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import { useAuth } from '../../auth'
import { PageMenuLink } from '../../../components/widgets'

const UserPagesMenu: FC = () => {

  const {hasRole, currentUser} = useAuth()

  if (! currentUser) {
    return null;
  }

  return (
  <div className='row'>
    <div className='col-12'>
      <div className='row'>
        <div className='col-lg-6 mb-3'>
          <h4 className='fs-6 fs-lg-4 text-gray-800 fw-bold mt-3 mb-3 ms-4'>Certification</h4>
          { (currentUser.role !== 'System Admin') &&
          <PageMenuLink title="COC Applications" to='/setsco/application-management/applications' />
          }

          { hasRole(['CAMS Admin','CAMS Program Manager','CAMS Inspector','CAMS Second Reviewer']) &&
          <PageMenuLink title="Certificates" to='/setsco/certificate-management/certificates' />
          }

          { (hasRole('CAMS Admin')) &&
          <>
          <h4 className='fs-6 fs-lg-4 text-gray-800 fw-bold mt-3 mb-3 ms-4'>Reports</h4>                    
          <PageMenuLink
            to='/setsco/reports/phase-statistics'
            title='Phase Statistics'
          />
          <PageMenuLink
            to='/setsco/reports/application-statistics'
            title='Application Statistics'                    
          />
          <PageMenuLink
            to='/setsco/reports/user-statistics'
            title='User Statistics'
          />
          <PageMenuLink
            to='/setsco/reports/user-phase-statistics'
            title='User Phase Statistics'
          />
          <PageMenuLink
            to='/setsco/reports/billings'
            title='Billings'
          />                  
          </>
          }

          { (hasRole('Super Admin')) &&
          <PageMenuLink
            to='/setsco/reports/summary-statistics'
            title='Summary Statistics'
          />                  
          }

          { (hasRole(['CAMS Admin','System Admin','CAMS Program Manager','DLM Admin'])) &&
          <>
          <h4 className='fs-6 fs-lg-4 text-gray-800 fw-bold mt-3 mb-3 ms-4'>Settings</h4>
          { (hasRole(['CAMS Admin','System Admin','CAMS Program Manager'])) &&
          <PageMenuLink
            to='/setsco/producttype-management/producttypes'
            title="Product Types"                    
          />
          }

          { (hasRole(['User Admin','Super Admin'])) &&
          <>
          <PageMenuLink
            to='/setsco/user-management/users'
            title="Users"                    
          />
          </>
          }

          { (hasRole(['CAMS Admin','System Admin'])) &&                    
          <PageMenuLink
            to='/setsco/company-management/companies'
            title="Companies"                    
          />
          }

          { (hasRole(['Super Admin','System Admin'])) &&                    
          <PageMenuLink
            to='/setsco/clientmanager-management/clientmanagers'        
            title="Client Managers" 
          />                                
          }

          { (hasRole(['System Admin','DLM Admin'])) &&
          <>
          <PageMenuLink
            to='/setsco/doclabel-management/dlmtypes'
            title="DLM Types"                    
          />
          <PageMenuLink
            to='/setsco/doclabel-management/labelsets'
            title="Label Sets"                    
          />
          <PageMenuLink
            to='/setsco/doclabel-management/threshold-list'
            title="Thresholds"                    
          />
          </>
          }

          { (hasRole(['Super Admin'])) &&
          <>
          <PageMenuLink
            to='/setsco/prices-settings/prices'
            title="Price Settings"                    
          />
          </>
          }

          { (hasRole(['Super Admin','System Admin'])) &&
          <PageMenuLink
            to='/setsco/system-settings/configuration'
            title="Config"                    
          />                    
          }
          </>
          }    
        </div>
        <div className='col-lg-6 mb-3'>

          { ((currentUser.role !== 'System Admin') && (hasRole(['System Admin','DLM Admin','DLM Program Manager','DLM Inspector']))) &&
          <>
          <h4 className='fs-6 fs-lg-4 text-gray-800 fw-bold mt-3 mb-3 ms-4'>Site Inspections</h4>
          <PageMenuLink title="Site Inspection Applications" to='/setsco/doclabel-management/siteinspection-applications-list' />
          <PageMenuLink title="Inspections List" to='/setsco/doclabel-management/siteinspection-applications-list' />

          <h4 className='fs-6 fs-lg-4 text-gray-800 fw-bold mt-3 mb-3 ms-4'>DOCs</h4>
          <PageMenuLink title="DOC Applications" to='/setsco/doclabel-management/doc-applications-list' />
          <PageMenuLink title="DOC List" to='/setsco/doclabel-management/doc-list' />

          <h4 className='fs-6 fs-lg-4 text-gray-800 fw-bold mt-3 mb-3 ms-4'>Labels</h4>
          <PageMenuLink title="Label Applications" to='/setsco/doclabel-management/label-applications-list' />
          <PageMenuLink title="Site Applications" to='/setsco/doclabel-management/label-site-applications-list' />
          <PageMenuLink title="ROI List" to='/setsco/doclabel-management/roi-list' />
          <PageMenuLink title="Label Search" to='/setsco/doclabel-management/labels-list' />                    
          </>
          }

          { ((currentUser.role !== 'System Admin') && (hasRole(['CAMS Quotation Admin']))) &&
          <>
          <h4 className='fs-6 fs-lg-4 text-gray-800 fw-bold mt-3 mb-3 ms-4'>Site Inspection Applications</h4>
          <PageMenuLink title="Site Inspection Applications" to='/setsco/doclabel-management/siteinspection-applications-list' />
          </>
          }
        </div>
      </div>
    </div>
  </div>
  )
}

export {UserPagesMenu}
